export default __webpack_public_path__ + "static/media/cloud-3.3683836d.webp";